<template>
  <Modal :value="showModal" @input="closeModal" headerText="Important message about your new Fund administrator" tabindex="0">
            <template #modal-body>
                <div class="p-4">
                    <p class="mb-4">Your new Fund administrator is Lane Clark &amp; Peacock. The announcements below provide more information.
</p>
                    <div class="announcements">
                    <div class="announcement active" :style="{backgroundImage: `url(${directoryUrl}/img/active-icon.png)`}" @click="openDocument('announcement-for-active-members.pdf')"
                    tabindex="0"
                    role="link"
                    aria-label="Announcement for active members">
                        Announcement for active members
                    </div>
                    <div class="announcement deferred" :style="{backgroundImage: `url(${directoryUrl}/img/deferred-icon.png)`}" @click="openDocument('announcement-for-deferred-members.pdf')"
                    tabindex="0"
                    role="link"
                    aria-label="Announcement for deferred members">
                        Announcement for deferred members
                    </div>
                    <div class="announcement pensioners"
                    :style="{backgroundImage: `url(${directoryUrl}/img/pensioner-icon.png)`}"
                    @click="openDocument('announcement-for-pensioners.pdf')"
                    tabindex="0"
                    role="link"
                    aria-label="Announcement for pensioners">
                        Announcement for pensioners
                    </div>
                    </div>
                </div>
            </template>
        </Modal>
</template>

<script>
import Modal from '@/components/layout/Modal.vue';
import dayjs from 'dayjs';


export default {
    components: {
        Modal,
    },

    data () {
        return {
            showModal: false,
        };
    },

    created () {
        this.checkIfModalShouldShow();
    },

    computed: {
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
    },
    methods: {
        checkIfModalShouldShow () {
            const launchCommsModal = localStorage.getItem('launchCommsModal');
            if (launchCommsModal) {
                if (launchCommsModal < dayjs().valueOf()) {
                    this.showModal = true;
                }
            } else {
                this.showModal = true;
            }
        },
        closeModal () {
            localStorage.setItem('launchCommsModal', dayjs().add(1, 'day').valueOf());
            this.showModal = false;
        },
        openDocument (filename) {
            window.open(`${this.directoryUrl}/documents/${filename}`, '_blank');
        },
    },

};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_mixins.scss';
.announcements{
    display: flex;;
    @include responsive("md"){
        flex-direction: column;
    }
.announcement{
    padding: 20px;
    padding-left: 70px;
    border-radius: 10px;
    box-shadow: $boxShadow2;
    background-repeat: no-repeat;
    background-position: (10px, 10px);
    margin-right:20px;
    transition: 0.3s all ease-in-out;
    cursor: pointer;
    font-weight: bold;
     background-size: 50px;
     @include responsive("md"){
        margin-bottom: 10px;
        width: 100%;
    }
    &:hover, &:focus-visible{
        box-shadow: $boxShadow;
    }
    &:last-child {
        margin-right: 0;
    }
    &.active{
        border: 5px solid #cdc400;
    }
    &.deferred{
        border: 5px solid #00a8da;
    }
    &.pensioners{
        border: 5px solid #009e8f;
    }
}
}

</style>
